// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__bPGVK","amount":"Circle_amount__TNV9V","title":"Circle_title__vXnqL","text":"Circle_text__N-kl+","fa-beat":"Circle_fa-beat__-VxZf"};